module.exports = __webpack_public_path__ + "img/product_mb_new_03.ff86a6c.webp";